import $ from "jquery";

const loadingState = () => {
    const init = () => {
        $(function () {
            const section = $(".loading-state");

            setTimeout(() => {
                section.removeClass("loading-state").addClass("loaded");
            }, 1000);
        });
    };

    init();
};

try {
    loadingState();
} catch (error) {
    console.error('loadingState', error);
}
